// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"711c3c23","677":"a37cc36f","706":"5428f318"}[chunkId] + ".chunk.js";
};